// helpers/exportClientVisits.js
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { format } from 'date-fns';

// export const exportToExcel = (data) => {
//   const wb = XLSX.utils.book_new();

//   const headers = [
//     'S.No',
//     'Client ID',
//     'Division',
//     'Division Base ID',
//     'Client Name',
//     'Industry Type',
//     'Industry Sub Type',
//     'Contact Name',
//     'Contact Phone',
//     'Contact Email',
//     'Product Category',
//     'Requirements',
//     'Estimated Value',
//     'Expected Value',
//     'Currency',
//     'Stage',
//     'Stage Probability',
//     'Payment Status',
//     'Total Visit Count',
//     'Last Visit Date',
//     'Next Follow Up',
//     'Created By',
//     'User ID',
//     'Role',
//     'Created Date'
//   ];

//   const excelData = data.map((visit, index) => [
//     `${index + 1}`,
//     visit.clientId,
//     visit.divisionId?.name || '-',
//     visit.divisionBaseId || '-',
//     visit.clientName,
//     visit.industryType,
//     visit.industrySubType || '-',
//     visit.contactName,
//     `${visit.contactPhone}` || '-',
//     visit.contactEmail || '-',
//     visit.productCategory?.join(', ') || '-',
//     visit.requirement?.join(', ') || '-',
//     `${visit.estimatedValue}` || '0',
//     `${visit.expectedValue}` || '0',
//     visit.currency,
//     visit.stageId?.stageName || '-',
//     `${visit.stageId?.probability}` || '0',
//     visit.paymentStatus.toUpperCase(),
//     `${visit.totalVisitCount}` || '0',
//     visit.lastVisitDate ? format(new Date(visit.lastVisitDate), 'dd-MM-yyyy') : '-',
//     visit.nextFollowUpDate ? format(new Date(visit.nextFollowUpDate), 'dd-MM-yyyy') : '-',
//     `${visit.createdBy?.firstName || ''} ${visit.createdBy?.lastName || ''}`.trim() || visit.userId?.firstName + ' ' + visit.userId?.lastName || '-',
//     visit.userId?.userId || '-',
//     visit.userId?.role || '-',
//     format(new Date(visit.createdAt), 'dd-MM-yyyy')
//   ]);

//   const ws = XLSX.utils.aoa_to_sheet([headers, ...excelData]);

//   // Calculate dynamic column widths based on content
//   const calculateColumnWidths = () => {
//     const columnWidths = [];
//     const allRows = [headers, ...excelData];
    
//     // For each column
//     for (let colIndex = 0; colIndex < headers.length; colIndex++) {
//       let maxWidth = 0;
      
//       // Check each row in this column
//       for (let rowIndex = 0; rowIndex < allRows.length; rowIndex++) {
//         const cellValue = String(allRows[rowIndex][colIndex] || '');
//         const cellLength = cellValue.length;
        
//         // Add extra padding for better readability
//         const paddedLength = cellLength + 2;
        
//         // Consider minimum and maximum widths
//         const effectiveWidth = Math.min(Math.max(paddedLength, 8), 50);
        
//         maxWidth = Math.max(maxWidth, effectiveWidth);
//       }
      
//       // Set minimum widths for certain columns
//       const minWidths = {
//         0: 6,    // S.No
//         14: 10,  // Currency
//         16: 15,  // Stage Probability
//       };
      
//       const finalWidth = Math.max(maxWidth, minWidths[colIndex] || 10);
//       columnWidths.push({ wch: finalWidth });
//     }
    
//     return columnWidths;
//   };

//   // Apply calculated column widths
//   ws['!cols'] = calculateColumnWidths();

//   // Style the header row
//   const range = XLSX.utils.decode_range(ws['!ref']);
//   for (let C = range.s.c; C <= range.e.c; ++C) {
//     const address = XLSX.utils.encode_col(C) + "1"; // Row 1 is headers
//     if (!ws[address]) continue;
//     ws[address].s = {
//       font: { bold: true },
//       fill: { fgColor: { rgb: "E0E0E0" } },
//       alignment: { horizontal: "center", vertical: "center" }
//     };
//   }

//   // Apply left alignment to all data cells (excluding headers)
//   for (let R = 1; R <= data.length; ++R) { // Start from row 2 (after headers)
//     for (let C = 0; C < headers.length; ++C) {
//       const address = XLSX.utils.encode_cell({ r: R, c: C });
//       if (ws[address]) {
//         if (!ws[address].s) ws[address].s = {};
//         ws[address].s.alignment = { horizontal: "left", vertical: "center" };
//       }
//     }
//   }

//   XLSX.utils.book_append_sheet(wb, ws, 'Client Visits');
//   XLSX.writeFile(wb, `client_visits_${format(new Date(), 'ddMMyyyy_HHmmss')}.xlsx`);
// };

export const exportToExcel = (data) => {
  const wb = XLSX.utils.book_new();

  // Extended headers to include visit history fields
  const headers = [
    'S.No',
    'Client ID',
    'Division',
    'Division Base ID',
    'Client Name',
    'Industry Type',
    'Industry Sub Type',
    'Contact Name',
    'Contact Phone',
    'Contact Email',
    'Product Category',
    'Requirements',
    'Estimated Value',
    'Expected Value',
    'Currency',
    'Stage',
    'Stage Probability',
    'Payment Status',
    'Total Visit Count',
    'Last Visit Date',
    'Next Follow Up',
    'Created By',
    'User ID',
    'Role',
    'Created Date',
    // Visit History fields
    'Visit Number',
    'Visit Date',
    'Visit Time',
    'Visit Type',
    'Visit Remarks',
    'Visit Created By',
    'Visit Next Follow Up',
    'Visit Created At'
  ];

  // Flatten data to include visit history
  const excelData = [];
  let serialNo = 1;

  data.forEach((visit) => {
    if (visit.visitHistory && visit.visitHistory.length > 0) {
      visit.visitHistory.forEach((historyItem, historyIndex) => {
        if (historyIndex === 0) {
          // First row: Show all client data + first visit history
          excelData.push([
            `${serialNo}`,
            visit.clientId,
            visit.divisionId?.name || '-',
            visit.divisionBaseId || '-',
            visit.clientName,
            visit.industryType,
            visit.industrySubType || '-',
            visit.contactName,
            `${visit.contactPhone}` || '-',
            visit.contactEmail || '-',
            visit.productCategory?.join(', ') || '-',
            visit.requirement?.join(', ') || '-',
            `${visit.estimatedValue}` || '0',
            `${visit.expectedValue}` || '0',
            visit.currency,
            visit.stageId?.stageName || '-',
            `${visit.stageId?.probability}` || '0',
            visit.paymentStatus.toUpperCase(),
            `${visit.totalVisitCount}` || '0',
            visit.lastVisitDate ? format(new Date(visit.lastVisitDate), 'dd-MM-yyyy HH:mm') : '-',
            visit.nextFollowUpDate ? format(new Date(visit.nextFollowUpDate), 'dd-MM-yyyy') : '-',
            `${visit.createdBy?.firstName || ''} ${visit.createdBy?.lastName || ''}`.trim() || '-',
            visit.userId?.userId || '-',
            visit.userId?.role || '-',
            format(new Date(visit.createdAt), 'dd-MM-yyyy HH:mm'),
            // Visit History fields
            `${historyItem.visitNumber}` || '-',
            historyItem.visitDate ? format(new Date(historyItem.visitDate), 'dd-MM-yyyy HH:mm') : '-',
            historyItem.visitTime || '-',
            historyItem.visitType || '-',
            historyItem.remarks || '-',
            `${historyItem.createdBy?.firstName || ''} ${historyItem.createdBy?.lastName || ''}`.trim() || '-',
            historyItem.nextFollowUpDate ? format(new Date(historyItem.nextFollowUpDate), 'dd-MM-yyyy') : '-',
            historyItem.createdAt ? format(new Date(historyItem.createdAt), 'dd-MM-yyyy HH:mm') : '-'
          ]);
        } else {
          // Subsequent rows: Only show visit history data
          excelData.push([
            '',  // Empty S.No for continuation
            '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
            // Only Visit History fields
            `${historyItem.visitNumber}` || '-',
            historyItem.visitDate ? format(new Date(historyItem.visitDate), 'dd-MM-yyyy HH:mm') : '-',
            historyItem.visitTime || '-',
            historyItem.visitType || '-',
            historyItem.remarks || '-',
            `${historyItem.createdBy?.firstName || ''} ${historyItem.createdBy?.lastName || ''}`.trim() || '-',
            historyItem.nextFollowUpDate ? format(new Date(historyItem.nextFollowUpDate), 'dd-MM-yyyy') : '-',
            historyItem.createdAt ? format(new Date(historyItem.createdAt), 'dd-MM-yyyy HH:mm') : '-'
          ]);
        }
      });
      serialNo++;
    } else {
      // If no visit history, still create a row with empty visit history fields
      excelData.push([
        `${serialNo}`,
        visit.clientId,
        visit.divisionId?.name || '-',
        visit.divisionBaseId || '-',
        visit.clientName,
        visit.industryType,
        visit.industrySubType || '-',
        visit.contactName,
        `${visit.contactPhone}` || '-',
        visit.contactEmail || '-',
        visit.productCategory?.join(', ') || '-',
        visit.requirement?.join(', ') || '-',
        `${visit.estimatedValue}` || '0',
        `${visit.expectedValue}` || '0',
        visit.currency,
        visit.stageId?.stageName || '-',
        `${visit.stageId?.probability}` || '0',
        visit.paymentStatus.toUpperCase(),
        `${visit.totalVisitCount}` || '0',
        visit.lastVisitDate ? format(new Date(visit.lastVisitDate), 'dd-MM-yyyy HH:mm') : '-',
        visit.nextFollowUpDate ? format(new Date(visit.nextFollowUpDate), 'dd-MM-yyyy') : '-',
        `${visit.createdBy?.firstName || ''} ${visit.createdBy?.lastName || ''}`.trim() || '-',
        visit.userId?.userId || '-',
        visit.userId?.role || '-',
        format(new Date(visit.createdAt), 'dd-MM-yyyy HH:mm'),
        // Empty visit history fields
        '-', '-', '-', '-', '-', '-', '-', '-'
      ]);
      serialNo++;
    }
  });

  const ws = XLSX.utils.aoa_to_sheet([headers, ...excelData]);

  // Enhanced column width calculation
  const calculateColumnWidths = () => {
    const columnWidths = [];
    const allRows = [headers, ...excelData];
    
    // Predefined minimum widths for specific columns
    const minWidths = {
      0: 6,     // S.No
      1: 12,    // Client ID
      2: 15,    // Division
      3: 15,    // Division Base ID
      4: 20,    // Client Name
      5: 25,    // Industry Type
      6: 25,    // Industry Sub Type
      7: 20,    // Contact Name
      8: 15,    // Contact Phone
      9: 25,    // Contact Email
      10: 30,   // Product Category
      11: 35,   // Requirements
      12: 15,   // Estimated Value
      13: 15,   // Expected Value
      14: 10,   // Currency
      15: 15,   // Stage
      16: 15,   // Stage Probability
      17: 15,   // Payment Status
      18: 15,   // Total Visit Count
      19: 18,   // Last Visit Date
      20: 18,   // Next Follow Up
      21: 20,   // Created By
      22: 15,   // User ID
      23: 12,   // Role
      24: 18,   // Created Date
      25: 12,   // Visit Number
      26: 18,   // Visit Date
      27: 12,   // Visit Time
      28: 15,   // Visit Type
      29: 30,   // Visit Remarks
      30: 20,   // Visit Created By
      31: 18,   // Visit Next Follow Up
      32: 18    // Visit Created At
    };
    
    // Calculate column widths
    for (let colIndex = 0; colIndex < headers.length; colIndex++) {
      let maxWidth = minWidths[colIndex] || 10;
      
      // Check content width
      for (let rowIndex = 0; rowIndex < Math.min(allRows.length, 100); rowIndex++) {
        const cellValue = String(allRows[rowIndex][colIndex] || '');
        const cellLength = cellValue.length;
        const paddedLength = cellLength + 2;
        const effectiveWidth = Math.min(paddedLength, 50);
        maxWidth = Math.max(maxWidth, effectiveWidth);
      }
      
      columnWidths.push({ wch: maxWidth });
    }
    
    return columnWidths;
  };

  // Apply column widths
  ws['!cols'] = calculateColumnWidths();

  // Style the worksheet
  const range = XLSX.utils.decode_range(ws['!ref']);
  
  // Style header row
  for (let C = range.s.c; C <= range.e.c; ++C) {
    const address = XLSX.utils.encode_col(C) + "1";
    if (!ws[address]) continue;
    ws[address].s = {
      font: { 
        bold: true,
        color: { rgb: "FFFFFF" }
      },
      fill: { 
        fgColor: { rgb: "366092" }
      },
      alignment: { 
        horizontal: "center", 
        vertical: "center",
        wrapText: true
      },
      border: {
        top: { style: "thin", color: { rgb: "000000" } },
        bottom: { style: "thin", color: { rgb: "000000" } },
        left: { style: "thin", color: { rgb: "000000" } },
        right: { style: "thin", color: { rgb: "000000" } }
      }
    };
  }

  // Style data cells
  let currentClientRow = 1;
  for (let R = 1; R <= excelData.length; ++R) {
    // Check if this is a main client row (has S.No) or a continuation row
    const isMainRow = excelData[R - 1][0] !== '';
    
    if (isMainRow) {
      currentClientRow++;
    }
    
    for (let C = 0; C < headers.length; ++C) {
      const address = XLSX.utils.encode_cell({ r: R, c: C });
      if (ws[address]) {
        if (!ws[address].s) ws[address].s = {};
        
        // Different styling for main rows vs continuation rows
        const fillColor = isMainRow 
          ? (currentClientRow % 2 === 0 ? "E8F1FF" : "FFFFFF")
          : (currentClientRow % 2 === 0 ? "F5F9FF" : "FAFAFA");
        
        ws[address].s = {
          alignment: { 
            horizontal: "left", 
            vertical: "center",
            wrapText: true
          },
          fill: {
            fgColor: { rgb: fillColor }
          },
          border: {
            top: { style: "thin", color: { rgb: "D3D3D3" } },
            bottom: { style: "thin", color: { rgb: "D3D3D3" } },
            left: { style: "thin", color: { rgb: "D3D3D3" } },
            right: { style: "thin", color: { rgb: "D3D3D3" } }
          }
        };
        
        // Right align numeric columns
        if ([12, 13, 16, 18, 25].includes(C)) {
          ws[address].s.alignment.horizontal = "right";
        }
        
        // Center align specific columns
        if ([0, 14, 17, 27, 28].includes(C)) {
          ws[address].s.alignment.horizontal = "center";
        }
        
        // Highlight visit history columns for continuation rows
        if (!isMainRow && C >= 25) {
          ws[address].s.font = { bold: false, color: { rgb: "000000" } };
        }
      }
    }
  }

  // Add autofilter
  ws['!autofilter'] = { ref: `A1:${XLSX.utils.encode_col(headers.length - 1)}${excelData.length + 1}` };

  // Set row height for header
  if (!ws['!rows']) ws['!rows'] = [];
  ws['!rows'][0] = { hpx: 30 };

  // Merge cells for client data in continuation rows (optional)
  // This helps visually group the visit history for each client

  XLSX.utils.book_append_sheet(wb, ws, 'Client Visits');
  XLSX.writeFile(wb, `client_visits_detailed_${format(new Date(), 'ddMMyyyy_HHmmss')}.xlsx`);
};




// export const exportToPDF = (data, companyLogo) => {
//   // Use landscape A3 for maximum space
//   const doc = new jsPDF('l', 'mm', 'a3');
//   const pageWidth = doc.internal.pageSize.getWidth();
//   const pageHeight = doc.internal.pageSize.getHeight();

//   // Add logo with proper aspect ratio
//   if (companyLogo) {
//     const logoHeight = 15;
//     const logoWidth = logoHeight * 1.23; // Maintain 540x438 aspect ratio
//     doc.addImage(companyLogo, 'PNG', 10, 5, logoWidth, logoHeight);
//   }

//   // Header
//   doc.setFontSize(16);
//   doc.text('Client Visits Report', pageWidth / 2, 12, { align: 'center' });

//   doc.setFontSize(8);
//   doc.text(`Generated on: ${format(new Date(), 'dd-MM-yyyy HH:mm:ss')}`, pageWidth / 2, 18, { align: 'center' });

//   // Summary
//   const totalValue = data.reduce((sum, visit) => sum + (Number(visit.expectedValue) || 0), 0);
//   const totalVisits = data.reduce((sum, visit) => sum + (visit.totalVisitCount || 0), 0);
//   const currencyCode = data[0]?.currency || 'INR';
  
//   doc.setFontSize(8);
//   doc.text(`Total Clients: ${data.length} | Total Visits: ${totalVisits} | Total Value: ${totalValue.toLocaleString('en-IN')} ${currencyCode}`, 
//     pageWidth - 10, 12, { align: 'right' });

//   // Prepare table data
//   const tableData = [];
  
//   data.forEach((client, index) => {
//     // Main client row
//     const mainRow = [
//       index + 1,
//       client.clientId || '-',
//       client.clientName || '-',
//       client.divisionId?.name || '-',
//       client.industryType || '-',
//       client.stageId?.stageName || '-',
//       (client.expectedValue || 0).toLocaleString('en-IN'),
//       (client.estimatedValue || 0).toLocaleString('en-IN'),
//       currencyCode,
//       client.paymentStatus?.toUpperCase() || '-',
//       client.totalVisitCount || 0,
//       client.lastVisitDate ? format(new Date(client.lastVisitDate), 'dd-MM-yyyy') : '-',
//       `${client.createdBy?.firstName || ''} ${client.createdBy?.lastName || ''}`.trim() || '-',
//       client.userId?.role || '-'
//     ];
//     tableData.push(mainRow);

//     // Visit history
//     if (client.visitHistory && client.visitHistory.length > 0) {
//       // Add visit history header row
//       tableData.push([
//         '',
//         '',
//         'VISIT HISTORY',
//         '',
//         '',
//         '',
//         '',
//         '',
//         '',
//         '',
//         '',
//         '',
//         '',
//         ''
//       ]);

//       // Add each visit
//       client.visitHistory.forEach((visit) => {
//         const visitRow = [
//           '',
//           `Visit ${visit.visitNumber}`,
//           visit.visitType || '-',
//           `${format(new Date(visit.visitDate), 'dd-MM-yyyy')} ${visit.visitTime || '-'}`,
//           visit.remarks || 'No remarks',
//           '',
//           '',
//           '',
//           '',
//           '',
//           '',
//           format(new Date(visit.createdAt), 'dd-MM-yyyy'),
//           `${visit.createdBy?.firstName || ''} ${visit.createdBy?.lastName || ''}`,
//           visit.nextFollowUpDate ? format(new Date(visit.nextFollowUpDate), 'dd-MM-yyyy') : '-',
//         ];
//         tableData.push(visitRow);
//       });
//     }
//   });

//   // Table headers
//   const headers = [[
//     'S.No',
//     'Client ID',
//     'Client Name',
//     'Division',
//     'Industry Type',
//     'Stage',
//     'Expected Value',
//     'Estimated Value',
//     'Currency',
//     'Payment Status',
//     'Total Visits',
//     'Last Visit',
//     'Created By',
//     'Role'
//   ]];

//   // Calculate proportional column widths to fill entire page width
//   const availableWidth = pageWidth - 20; // Total width minus margins
//   const columnWidths = [
//     availableWidth * 0.03,   // S.No - 3%
//     availableWidth * 0.06,   // Client ID - 6%
//     availableWidth * 0.12,   // Client Name - 12%
//     availableWidth * 0.08,   // Division - 8%
//     availableWidth * 0.12,   // Industry Type - 12%
//     availableWidth * 0.08,   // Stage - 8%
//     availableWidth * 0.08,   // Expected Value - 8%
//     availableWidth * 0.08,   // Estimated Value - 8%
//     availableWidth * 0.05,   // Currency - 5%
//     availableWidth * 0.08,   // Payment Status - 8%
//     availableWidth * 0.05,   // Total Visits - 5%
//     availableWidth * 0.07,   // Last Visit - 7%
//     availableWidth * 0.08,   // Created By - 8%
//     availableWidth * 0.06    // Role - 6%
//   ];

//   // Generate table
//   autoTable(doc, {
//     head: headers,
//     body: tableData,
//     startY: 25,
//     theme: 'plain',
//     tableWidth: availableWidth, // Force table to use full available width
//     styles: {
//       fontSize: 7,
//       cellPadding: 2,
//       overflow: 'linebreak',
//       cellWidth: 'wrap',
//       halign: 'left'
//     },
//     headStyles: {
//       fillColor: false,
//       textColor: 20,
//       fontStyle: 'bold',
//       lineWidth: 0.1,
//       lineColor: 200,
//       halign: 'center'
//     },
//     bodyStyles: {
//       fillColor: false,
//       textColor: 20,
//       lineWidth: 0.1,
//       lineColor: 200
//     },
//     columnStyles: {
//       0: { cellWidth: columnWidths[0], halign: 'center' },
//       1: { cellWidth: columnWidths[1], halign: 'center' },
//       2: { cellWidth: columnWidths[2], halign: 'left' },
//       3: { cellWidth: columnWidths[3], halign: 'left' },
//       4: { cellWidth: columnWidths[4], halign: 'left' },
//       5: { cellWidth: columnWidths[5], halign: 'center' },
//       6: { cellWidth: columnWidths[6], halign: 'right' },
//       7: { cellWidth: columnWidths[7], halign: 'right' },
//       8: { cellWidth: columnWidths[8], halign: 'center' },
//       9: { cellWidth: columnWidths[9], halign: 'center' },
//       10: { cellWidth: columnWidths[10], halign: 'center' },
//       11: { cellWidth: columnWidths[11], halign: 'center' },
//       12: { cellWidth: columnWidths[12], halign: 'left' },
//       13: { cellWidth: columnWidths[13], halign: 'center' }
//     },
//     didParseCell: function(data) {
//       // Style visit history header rows
//       if (data.row.raw[2] === 'VISIT HISTORY') {
//         data.cell.styles.fontStyle = 'bold';
//         data.cell.styles.fontSize = 7;
//       }
      
//       // Style visit rows
//       if (data.row.raw[1] && typeof data.row.raw[1] === 'string' && data.row.raw[1].startsWith('Visit')) {
//         data.cell.styles.fontSize = 6;
//         data.cell.styles.cellPadding = 1;
//       }

//       // Payment status styling (no colors, just bold)
//       if (data.column.index === 9 && data.section === 'body') {
//         const status = String(data.cell.raw).toLowerCase();
//         if (status === 'pending' || status === 'partial' || status === 'completed') {
//           data.cell.styles.fontStyle = 'bold';
//         }
//       }
//     },
//     margin: { left: 10, right: 10 },
//     showHead: 'everyPage',
//     pageBreak: 'auto'
//   });

//   // Page numbers
//   const totalPages = doc.internal.getNumberOfPages();
//   for (let i = 1; i <= totalPages; i++) {
//     doc.setPage(i);
//     doc.setFontSize(8);
//     doc.text(`Page ${i} of ${totalPages}`, pageWidth / 2, pageHeight - 5, { align: 'center' });
//   }

//   // Save
//   doc.save(`client_visits_${format(new Date(), 'dd-MM-yyyy_HHmm')}.pdf`);
// };

export const exportToPDF = (data, companyLogo) => {
  // Use landscape A3 for maximum space
  const doc = new jsPDF('l', 'mm', 'a3');
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  // Add logo with proper aspect ratio
  if (companyLogo) {
    const logoHeight = 15;
    const logoWidth = logoHeight * 1.23; // Maintain 540x438 aspect ratio
    doc.addImage(companyLogo, 'PNG', 10, 5, logoWidth, logoHeight);
  }

  // Header
  doc.setFontSize(16);
  doc.text('Client Visits Report', pageWidth / 2, 12, { align: 'center' });

  doc.setFontSize(8);
  doc.text(`Generated on: ${format(new Date(), 'dd-MM-yyyy HH:mm:ss')}`, pageWidth / 2, 18, { align: 'center' });

  // Summary - moved left to avoid edge
  const totalValue = data.reduce((sum, visit) => sum + (Number(visit.expectedValue) || 0), 0);
  const totalVisits = data.reduce((sum, visit) => sum + (visit.totalVisitCount || 0), 0);
  const currencyCode = data[0]?.currency || 'INR';
  
  doc.setFontSize(8);
  doc.text(`Total Clients: ${data.length} | Total Visits: ${totalVisits} | Total Value: ${totalValue.toLocaleString('en-IN')} ${currencyCode}`, 
    pageWidth - 15, 12, { align: 'right' });

  // Prepare table data
  const tableData = [];
  
  data.forEach((client, index) => {
    // Main client row
    const mainRow = [
      index + 1,
      client.clientId || '-',
      client.clientName || '-',
      client.divisionId?.name || '-',
      client.industryType || '-',
      client.stageId?.stageName || '-',
      (client.expectedValue || 0).toLocaleString('en-IN'),
      (client.estimatedValue || 0).toLocaleString('en-IN'),
      currencyCode,
      client.paymentStatus?.toUpperCase() || '-',
      client.totalVisitCount || 0,
      client.lastVisitDate ? format(new Date(client.lastVisitDate), 'dd-MM-yyyy') : '-',
      `${client.createdBy?.firstName || ''} ${client.createdBy?.lastName || ''}`.trim() || '-',
      client.userId?.role || '-'
    ];
    tableData.push(mainRow);

    // Visit history
    if (client.visitHistory && client.visitHistory.length > 0) {
      // Add visit history header row
      tableData.push([
        '',
        '',
        'VISIT HISTORY',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        ''
      ]);

      // Add each visit
      client.visitHistory.forEach((visit) => {
        const visitRow = [
          '',
          `Visit ${visit.visitNumber}`,
          visit.visitType || '-',
          `${format(new Date(visit.visitDate), 'dd-MM-yyyy')} ${visit.visitTime || '-'}`,
          visit.remarks || 'No remarks',
          '',
          '',
          '',
          '',
          '',
          '',
          format(new Date(visit.createdAt), 'dd-MM-yyyy'),
          `${visit.createdBy?.firstName || ''} ${visit.createdBy?.lastName || ''}`,
          visit.nextFollowUpDate ? format(new Date(visit.nextFollowUpDate), 'dd-MM-yyyy') : '-',
        ];
        tableData.push(visitRow);
      });
    }
  });

  // Table headers
  const headers = [[
    'S.No',
    'Client ID',
    'Client Name',
    'Division',
    'Industry Type',
    'Stage',
    'Expected Value',
    'Estimated Value',
    'Currency',
    'Payment Status',
    'Total Visits',
    'Last Visit',
    'Created By',
    'Role'
  ]];

  // Calculate proportional column widths to fit all columns properly
  const leftMargin = 10;
  const rightMargin = 15; // Maintain right margin
  const availableWidth = pageWidth - leftMargin - rightMargin;
  
  // Optimized column widths to ensure all columns fit
  const columnWidths = [
    availableWidth * 0.03,   // S.No - 3%
    availableWidth * 0.06,   // Client ID - 6%
    availableWidth * 0.11,   // Client Name - 11% (reduced from 12%)
    availableWidth * 0.07,   // Division - 7% (reduced from 8%)
    availableWidth * 0.11,   // Industry Type - 11% (reduced from 12%)
    availableWidth * 0.07,   // Stage - 7% (reduced from 8%)
    availableWidth * 0.08,   // Expected Value - 8%
    availableWidth * 0.08,   // Estimated Value - 8%
    availableWidth * 0.05,   // Currency - 5%
    availableWidth * 0.08,   // Payment Status - 8%
    availableWidth * 0.05,   // Total Visits - 5%
    availableWidth * 0.07,   // Last Visit - 7%
    availableWidth * 0.08,   // Created By - 8%
    availableWidth * 0.06    // Role - 6%
  ];

  // Verify total width doesn't exceed available width
  const totalWidth = columnWidths.reduce((sum, width) => sum + width, 0);
  console.log('Total column width:', totalWidth, 'Available width:', availableWidth);

  // Generate table
  autoTable(doc, {
    head: headers,
    body: tableData,
    startY: 25,
    theme: 'grid', // Changed to grid for better visibility
    tableWidth: availableWidth,
    styles: {
      fontSize: 7,
      cellPadding: 1.5, // Reduced padding to save space
      overflow: 'linebreak',
      cellWidth: 'wrap',
      halign: 'left',
      valign: 'middle',
      minCellHeight: 4
    },
    headStyles: {
      fillColor: [54, 96, 146], // Professional blue
      textColor: [255, 255, 255], // White text
      fontStyle: 'bold',
      fontSize: 7,
      lineWidth: 0.1,
      lineColor: [200, 200, 200],
      halign: 'center',
      cellPadding: 2
    },
    bodyStyles: {
      fillColor: false,
      textColor: [20, 20, 20],
      lineWidth: 0.1,
      lineColor: [200, 200, 200]
    },
    alternateRowStyles: {
      fillColor: [245, 245, 245] // Light gray for alternate rows
    },
    columnStyles: {
      0: { cellWidth: columnWidths[0], halign: 'center' },
      1: { cellWidth: columnWidths[1], halign: 'center' },
      2: { cellWidth: columnWidths[2], halign: 'left' },
      3: { cellWidth: columnWidths[3], halign: 'left' },
      4: { cellWidth: columnWidths[4], halign: 'left' },
      5: { cellWidth: columnWidths[5], halign: 'center' },
      6: { cellWidth: columnWidths[6], halign: 'right' },
      7: { cellWidth: columnWidths[7], halign: 'right' },
      8: { cellWidth: columnWidths[8], halign: 'center' },
      9: { cellWidth: columnWidths[9], halign: 'center' },
      10: { cellWidth: columnWidths[10], halign: 'center' },
      11: { cellWidth: columnWidths[11], halign: 'center' },
      12: { cellWidth: columnWidths[12], halign: 'left' },
      13: { cellWidth: columnWidths[13], halign: 'center' }
    },
    didParseCell: function(data) {
      // Style visit history header rows
      if (data.row.raw[2] === 'VISIT HISTORY') {
        data.cell.styles.fontStyle = 'bold';
        data.cell.styles.fontSize = 7;
        data.cell.styles.fillColor = [220, 220, 220];
        data.cell.styles.textColor = [0, 0, 0];
      }
      
      // Style visit rows
      if (data.row.raw[1] && typeof data.row.raw[1] === 'string' && data.row.raw[1].startsWith('Visit')) {
        data.cell.styles.fontSize = 6;
        data.cell.styles.cellPadding = 1;
        data.cell.styles.fillColor = [250, 250, 250];
      }

      // Payment status styling
      if (data.column.index === 9 && data.section === 'body') {
        const status = String(data.cell.raw).toLowerCase();
        if (status === 'pending') {
          data.cell.styles.textColor = [255, 0, 0]; // Red
          data.cell.styles.fontStyle = 'bold';
        } else if (status === 'completed') {
          data.cell.styles.textColor = [0, 128, 0]; // Green
          data.cell.styles.fontStyle = 'bold';
        } else if (status === 'partial') {
          data.cell.styles.textColor = [255, 140, 0]; // Orange
          data.cell.styles.fontStyle = 'bold';
        }
      }

      // Make role column more visible
      if (data.column.index === 13) {
        data.cell.styles.fontStyle = 'bold';
      }
    },
    margin: { 
      left: leftMargin, 
      right: rightMargin,
      top: 5,
      bottom: 10 
    },
    showHead: 'everyPage',
    pageBreak: 'auto',
    horizontalPageBreak: true,
    willDrawCell: function(data) {
      // Ensure role column is visible
      if (data.column.index === 13 && data.section === 'body') {
        // Additional styling if needed
      }
    }
  });

  // Footer with page numbers
  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    
    // Footer line
    doc.setDrawColor(200);
    doc.setLineWidth(0.1);
    doc.line(10, pageHeight - 10, pageWidth - 15, pageHeight - 10); // Respect right margin
    
    // Page number
    doc.text(`Page ${i} of ${totalPages}`, pageWidth / 2, pageHeight - 5, { align: 'center' });
    
    // Date on footer
    doc.setFontSize(7);
    doc.text(`Printed on: ${format(new Date(), 'dd-MM-yyyy HH:mm')}`, 10, pageHeight - 5, { align: 'left' });
    
    // Report name on footer - moved left to respect margin
    doc.text('Client Visits Report', pageWidth - 15, pageHeight - 5, { align: 'right' });
  }

  // Save
  doc.save(`client_visits_${format(new Date(), 'dd-MM-yyyy_HHmm')}.pdf`);
};
